import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import OrigemAtendimentoModel from "@/models/origemAtendimentoModel";
import origemAtendimentoService from "@/services/origemAtendimentoService";

import ListComponentBase from "../listComponentBase";

@Component
export default class OrigemAtendimentoListComponent extends ListComponentBase<OrigemAtendimentoModel> {
    get gridColumns(): Array<GridColumn> {
        return [new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String)];
    }

    private beforeMount() {
        this.setPropsCached(origemAtendimentoService, "origemAtendimento", "descricao", true);
    }
}
